// extracted by mini-css-extract-plugin
export default {"spPage":"SafePurchase_spPage__pksYn","underline":"SafePurchase_underline__dAjvv","inline":"SafePurchase_inline__PC5F6","parWithPadding":"SafePurchase_parWithPadding__ykMyz"};